(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgProjectModule', sgProjectModule);

  function sgProjectModule () {

    return {
      template: '<span id="{{::\'module-\'+module._id}}" mongoose-id="{{::module._id}}" ng-transclude></span>',
      restrict: 'E',
      transclude: true
    };
  }

})();
